module.exports = __webpack_public_path__ + "static/img/loading.790ce70d.gif";